import { Container } from "@mui/material";
import { Mail } from "../../components/common/Mail";
import { Phone } from "../../components/common/Phone";
import styles from "./HomePage.module.scss";

export const HomePage = () => {
  return (
    <>
      <Container className={styles.backgroundImage} maxWidth={false} />

      <Container className={styles.mainTitle}>
        <h1>
          Hurtownia Łożysk Warszawa — dobre i tanie wysokiej jakości piasty
          samochodowe
        </h1>
        <p>
          Twój samochód buczy w czasie jazdy? Słyszysz wycie, szumy, stuki? Mogą
          to być objawy uszkodzonego lub zużytego łożyska. W przypadku takiej
          awarii istotne jest szybkie działanie, dzięki któremu koszty naprawy
          będą niższe. Jednocześnie nowe łożyska samochodowe potrafią kosztować
          niemało.
        </p>
      </Container>

      <Container className={styles.boxes}>
        <div>
          <img src="car1.png" alt="Car" />
          <div>
            <h6>Łożyska kół</h6>
            <p>
              Najczęstsze przyczyny uszkodzeń łożysk. Dowiedz się co je
              powoduje.
            </p>
          </div>
        </div>

        <div>
          <img src="car2.png" alt="Engine" />
          <div>
            <h6>Złóż zamówienie</h6>
            <p>
              Zamówienia na łożyskapiasty.pl można składać 24 godziny na dobę 7
              dni w tygodniu.
            </p>
          </div>
        </div>

        <div>
          <img src="car3.png" alt="Engine" />
          <div>
            <h6>
              Chcesz sprawdzić czy wybrana część pasuje do Twojego samochodu?
            </h6>
          </div>
        </div>

        <div>
          <img src="car4.jpg" alt="Red car" />
          <div>
            <h6>Skontaktuj się z nami!</h6>
            <p>
              Zadzwoń <Phone /> lub napisz pod adres <Mail />
            </p>
          </div>
        </div>
      </Container>

      <Container className={styles.shopInfo}>
        <div>
          <h2>Sklep łożyska Warszawa</h2>
          <p>
            Jeżeli mieszkasz w stolicy naszego kraju lub w okolicy i szukasz
            placówki, gdzie kupisz wysokiej jakości łożyska, to możesz odwiedzić
            nasz sklep. Znajdziesz u nas części zamienne, które przydadzą Ci się
            podczas naprawy auta. Oczywiście zamówienia realizujemy na terenie
            całej Polski. Dlatego, jeżeli nie mieszkasz w Warszawie, a szukasz
            sklepu, który posiada duży wybór łożysk, to również możesz złożyć
            zamówienie. Części zostaną wysłane kurierem — do Ciebie lub do
            wskazanego przez Ciebie warsztatu. Wszystkie produkty Nowości
            Promocje
          </p>
        </div>

        <div>
          <h2>Piasty, łożyska — sklep z dużym doświadczeniem</h2>
          <p>
            Posiadamy ponad 10-letnie doświadczenie w sprzedaży łożysk.
            Współpracujemy zarówno z klientami indywidualnymi, jak i firmami. To
            wszystko przekłada się na jakość naszych usług na każdym etapie.
            Wiąże się do przede wszystkim z jakością oferowanych części — u nas
            znajdziesz zarówno oryginalne piasty, jak i zamienniki. Oczywiście
            bez względu na to, jaki produkt zamawiasz, to możesz liczyć na to,
            że jest on w 100% sprawny. Duże doświadczenie przekłada się również
            na szybkość realizacji zamówienia. Ponadto w razie braku potrzebnych
            części jesteśmy w stanie szybko zorganizować potrzebne piasty i
            łożyska. Dzięki temu wielu klientów często do nas wraca i ponownie
            korzysta z naszych usług.
          </p>
        </div>

        <div>
          <h2>
            Nie tylko sklep motoryzacyjny z łożyskami i piastami samochodowymi
          </h2>
          <p>
            Warto zauważyć, że znajdziesz u nas nie tylko hurtownię łożysk w
            Warszawie. Oprócz tego na naszej stronie jest dział „wiedza”, w
            którym znajdziesz przydatne artykuły, pomocne w przypadku awarii
            piasty lub łożyska. Zastanawiasz się, dlaczego łożyska zostały
            uszkodzone? A może szukasz odpowiedzi na inne pytania — znajdziesz
            je u nas. Wiemy, jak ważne jest zadowolenie klientów, dlatego
            służymy im pomocą. Z rad specjalistów możesz również skorzystać,
            odwiedzając nasz sklep stacjonarny w Warszawie, albo kontaktując się
            z nami zdalnie. Doświadczeni eksperci pomogą podjąć najlepsze
            decyzje zakupowe. Kontaktując się z nami, możesz również sprawdzić,
            czy dana część pasuje do twojego samochodu. Dlatego, jeżeli masz
            jakiekolwiek wątpliwości co do zakupu, to nie czekaj — wypełnij
            formularz kontaktowy, napisz maila lub zadzwoń.
          </p>
        </div>
      </Container>
    </>
  );
};
